import React, { FC } from 'react';
import { IConfig } from '../../types/config';

import { IFooter1 } from './Footer_1/params';
import { IFooter2 } from './Footer_2/params';
import { IFooter3 } from './Footer_3/params';

import Footer1 from './Footer_1';
import Footer2 from './Footer_2';
import Footer3 from './Footer_3';

const Footer: FC<{ config: IConfig; categories: string[]; language: string }> = ({ config, categories, language }) => {
  const siteNameAlias = config.general.siteNameAlias || config.general.siteName;

  switch (config.general.footer.variant) {
    case 3:
    case '3':
      return (
        <Footer3
          config={config.general.footer.params as IFooter3}
          siteNameAlias={siteNameAlias}
          categories={categories}
          language={language}
        />
      );
    case 2:
    case '2':
      return (
        <Footer2
          config={config.general.footer.params as IFooter2}
          siteNameAlias={siteNameAlias}
          categories={categories}
          language={language}
        />
      );
    default:
      return <Footer1 config={config.general.footer.params as IFooter1} language={language} />;
  }
};

export default Footer;
